import React from 'react';
import { Stat } from './Stat';
import { StreakIcon } from '../../theme/Icons';
import { ICareCheckin, IPersonalCheckin } from '../model/ICheckin';
import dayjs from 'dayjs';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CheckinState } from '../model/CheckinState';

export interface IEntryStreakProps {
    personalCheckins: IPersonalCheckin[];
    careCheckins: ICareCheckin[];
}
export const EntryStreak: React.FC<IEntryStreakProps> = ({ personalCheckins, careCheckins }) => {

    const checkinState = useInstance(CheckinState);

    const hasAnyData = (_day: dayjs.Dayjs) => {
        const dateString = _day.format('YYYY-MM-DD');
        for (const checkins of [personalCheckins, careCheckins]) {
            const checkin = checkins.find(c => c.timestamp.startsWith(dateString));
            if (checkin && checkinState.hasData(checkin)) {
                return true;
            }
        }
        return false;
    };

    let streak = 0;
    let day = dayjs();

    while (true) {
        const found = hasAnyData(day);
        if (found) {
            streak++;
        }
        // if found (or it's today, which is optional) continue to previous day
        if (found || day.isToday()) {
            day = day.subtract(1, 'day');
            continue;
        }
        // not found, end of streak
        break;
    }

    return (
        <Stat
            data-id="streak-stat"
            label="day streak!"
            value={streak}
            Icon={StreakIcon}
            iconColor="theme-yellow"
        />
    );
};
